import { BiDumbbell } from 'react-icons/bi'
import { FaRunning } from 'react-icons/fa'
import { ImFire } from 'react-icons/im'
import { RiHeartPulseFill } from 'react-icons/ri'

export const programsData = [
  {
    image: <BiDumbbell />,
    heading: "Strength Training",
    details:
      "In this program, you are trained to improve your strength through many exercises.",
  },
  {
    image: <FaRunning />,
    heading: "Cardio Training",
    details:
      "In this program, you are trained to do sequential moves in range of 20 until 30 minutes.",
  },
  {
    image: <ImFire />,
    heading: "Fat Burning",
    details:
      "This program is suitable for you who wants to get rid of your fat and lose their weight.",
  },
  {
    image: <RiHeartPulseFill />,
    heading: "Health Fitness",
    details:
      "This programs is designed for those who exercises only for their body fitness not body building.",
  },
];



